import { Component } from '@angular/core';
import {
    UilabMatProgressBarModule,
    UilabMatProgressSpinnerModule,
} from '@uilab/ng-mat-components';
import { CodeExampleComponent } from 'src/app/shared/components/code-example/code-example.component';
import { CodeExampleHeaderComponent } from 'src/app/shared/components/code-example/code-example-header.component';
import { COMPONENT_EXAMPLES_CONSTANTS } from '../component-examples.constants';

interface ProgressIndicatorsExample {
    readonly variant: 'determinate-bar' | 'default-spinner';
    readonly label: string;
    readonly description: string;
    readonly htmlSnippet: string;
    readonly storybookLink?: string;
    readonly value?: number;
    readonly mode: 'determinate' | 'indeterminate';
    readonly diameter?: number;
}

@Component({
    selector: 'avd-progress-indicators-examples',
    templateUrl: './progress-indicators-examples.component.html',
    styleUrls: ['./progress-indicators-examples.component.scss'],
    imports: [
        CodeExampleHeaderComponent,
        CodeExampleComponent,
        UilabMatProgressBarModule,
        UilabMatProgressSpinnerModule,
    ],
})
export class ProgressIndicatorsExamplesComponent {
    readonly packageName = COMPONENT_EXAMPLES_CONSTANTS.PACKAGE_NAME;
    readonly getStartedLink = COMPONENT_EXAMPLES_CONSTANTS.GET_STARTED_LINK;
    readonly storybookLink =
        'https://calm-mushroom-0d2458d1e.2.azurestaticapps.net/?path=/story/components-progress-bar--determinate';
    readonly repoLink = `${COMPONENT_EXAMPLES_CONSTANTS.AZURE_DEVOPS_BASE_URL}&path=/projects/components/src/lib/progress-bar`;

    readonly examples: readonly ProgressIndicatorsExample[] = [
        {
            variant: 'determinate-bar',
            label: 'Determinate Progress Bar',
            description:
                'Use a determinate progress bar when the completion percentage is known.',
            htmlSnippet:
                '<uilab-mat-progress-bar mode="determinate" [value]="40"></uilab-mat-progress-bar>',
            storybookLink:
                'https://calm-mushroom-0d2458d1e.2.azurestaticapps.net/?path=/story/components-progress-bar--determinate',
            mode: 'determinate',
            value: 40,
        },
        {
            variant: 'default-spinner',
            label: 'Default Progress Spinner',
            description:
                'Use an indeterminate spinner when progress duration is unknown.',
            htmlSnippet:
                '<uilab-mat-progress-spinner mode="indeterminate"></uilab-mat-progress-spinner>',
            storybookLink:
                'https://calm-mushroom-0d2458d1e.2.azurestaticapps.net/?path=/story/components-progress-spinner--default',
            mode: 'indeterminate',
            diameter: 40,
        },
    ];
}
